<template>
  <div class="main-wrapper" v-if="serviceCodes">

    <el-table :data="serviceCodes" width="100%">
      <el-table-column label="ICP 备案服务码">
        <template #default="scope">
          {{ scope.row.code || '服务码申请中，请稍后' }}
        </template>
      </el-table-column>
      <el-table-column label="网站云">
        <template #default="scope">
          <template v-if="scope.row.host">
            <el-link
              type="primary"
              style="margin-right: 5px"
              :underline="false"
              :href="getUrl(scope.row.host)"
              target="_blank"
            >
              {{ getUniqueName(scope.row.host) }}
            </el-link>
            <br v-if="scope.row.host.nickName" />
            <el-link :underline="false" @click.prevent>
              {{ scope.row.host.nickName }}
            </el-link>
          </template>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template #default="scope">
          {{ scope.row.isFree ? '免费' : '收费' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template #default="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
    </el-table>

    <el-divider></el-divider>

    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click.prevent="btnBuyClick">申请ICP备案服务码</el-button>
      </el-form-item>
    </el-form>

    <el-drawer title="申请ICP备案服务码" direction="rtl" size="60%" :destroy-on-close="true" v-model="isBuy">
      <buy @close="btnBuyCloseClick" />
    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IHost, IServiceCode } from '@/types/models';
import api from '@/api/my/serviceCodes';
import utils from '@/utils';
import Buy from './components/serviceCodes/Buy.vue';

interface IState {
  serviceCodes: IServiceCode[];
  isBuy: boolean;
}

export default defineComponent({
  components: {
    Buy,
  },
  data() {
    return {
      serviceCodes: [],
      isBuy: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.serviceCodes = res.serviceCodes;
      });
    },

    getUrl(host: IHost): string {
      return utils.getHostUrl(host.hostName, host.nodeName, host.isHongKong);
    },

    getUniqueName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    btnBuyClick() {
      this.isBuy = true;
    },

    btnBuyCloseClick() {
      this.isBuy = false;
      this.apiGet();
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
